<template>
  <div class="file-wrapper">
    <div v-if="!error" class="md-layout align-center">
      <div :class="uploaded ? 'video-uploaded' : ''">
        <video
          v-show="uploaded && processed"
          ref="videoPlayer"
          controls
          preload="auto"
          class="video-js vjs-has-started"
        ></video>

        <img v-show="uploaded && !processed" src="../../../assets/video_processing.svg" />

        <span v-if="!uploaded">
          {{ dataProps.link }}
          <md-progress-spinner class="md-accent" :md-diameter="30" md-mode="indeterminate"></md-progress-spinner>
        </span>
      </div>
      <div class="delete-icon" :class="uploaded ? 'delete-icon-uploaded' : ''">
        <md-button v-if="!noDelete" @click="$emit('delete')" class="md-icon-button">
          <md-icon>close</md-icon>
        </md-button>
      </div>
    </div>
    <div v-if="error" class="md-layout align-left">
      <div data-drupal-messages class="messages__wrapper layout-container">
        <div class="messages messages--error file-error">
          <ul class="messages__list">
            <li
              class="messages__item"
            >The selected file {{name}} cannot be uploaded. File must be less than 256mb. Only files with the following extensions are allowed: mp4, mov, webm, ogv</li>
          </ul>
          <md-button @click="$emit('upload-file-fail')" class="md-icon-button">
            <md-icon>close</md-icon>
          </md-button>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import contentDisposition from "content-disposition";
import videojs from "video.js";
import "video.js/dist/video-js.min.css";
import AnnotationComments from "@dbuzinov/videojs-annotation-comments/build/videojs-annotation-comments.cjs.js";
import "@dbuzinov/videojs-annotation-comments/build/css/annotations.css";
import HelpersMixin from "../../../HelpersMixin";
import VideoCommentMixin from "../../../VideoCommentMixin";

export default {
  name: "FbVideoViewFile",
  props: [
    "dataProps",
    "cleanError",
    "uploadUrl",
    "no-delete",
    "sid",
    "assignment",
    "allowCommenting",
  ],
  mixins: [HelpersMixin, VideoCommentMixin],
  computed: {
    processed() {
      return !(this.filemime == 'video/mov' || this.filemime == 'video/quicktime');
    },
    uploaded() {
      return this.dataProps.uuid != "";
    },
  },
  data() {
    return {
      options: {},
      error: false,
      errorMessage: "",
      token: "",
      uuid: this.dataProps.uuid || "",
      uri: this.dataProps.uri || "",
      filemime: this.dataProps.filemime || "",
      name: "",
    };
  },
  mounted() {
    this.submissionUuid = this.sid;
    this.fileurl =
      this.uploadUrl ||
      "/jsonapi/activity_submission/activity_submission/attached_files";
    if (
      this.dataProps.buffer &&
      (this.dataProps.buffer.byteLength || this.dataProps.buffer.size) &&
      this.dataProps.name
    ) {
      this.getToken().then(() => {
        this.uploadFile(this.dataProps.buffer, this.dataProps.link);
      });
    }
    if (this.uploaded && !this.player[this.uuid]) {
      let fn = [];
      if (this.assignment) {
        fn.push(this.getComments(this.uuid, this.assignment));
      }
      fn.push(this.getComments(this.uuid));
      Promise.all(fn).then((res) => {
        let comments = [];
        res.forEach((commentList) => {
          comments = comments.concat(commentList);
        });
        try {
          videojs.registerPlugin(
            "annotationComments",
            AnnotationComments(videojs)
          );
          let options = {
            controls: true,
            fluid: true,
            sources: [
              {
                src: this.uri,
                type: this.filemime,
              },
            ],
          };
          let self = this;
          if (self.$refs.videoPlayer) {
            self.player[self.uuid] = videojs(
              self.$refs.videoPlayer,
              options,
              () => {
                if (!self.plugin[self.uuid]) {
                  return;
                }
                // annotationDeleted : Fired when an annotation has been deleted via the UI
                self.plugin[self.uuid].registerListener(
                  "annotationDeleted",
                  (event) => {
                    let annotationUuid = event.detail.id;
                    let elementUuid = self.uuid;
                    self.deleteAnnotation(elementUuid, annotationUuid);
                  }
                );
                self.plugin[self.uuid].registerListener(
                  "onStateChanged",
                  (event) => {
                    // event.detail = annotation state data
                    let currentComment = {};
                    event.detail.forEach((annotation) => {
                      annotation.comments.map((comment) => {
                        currentComment[comment.id] = comment;
                        if (self.comments[comment.id]) {
                          return;
                        }
                        self.comments[comment.id] = comment;
                        // console.log(event, annotation);
                        self.setComment(
                          self.uuid,
                          comment.body,
                          {
                            annotation: annotation.id,
                            range: annotation.range,
                            shape: annotation.shape,
                            meta: comment.meta,
                          },
                          comment.id
                        );
                        // if (annotation.comments.lenght == 1) {
                        //   // First comment in annotation.
                        // }
                      });
                    });
                    let currentCommentIds = Object.keys(currentComment).map(
                      (comment) => {
                        return currentComment[comment].id;
                      }
                    );
                    let existingCommentIds = Object.keys(self.comments).map(
                      (comment) => {
                        return self.comments[comment].id;
                      }
                    );
                    let deleted = existingCommentIds.filter(
                      (x) => !currentCommentIds.includes(x)
                    );
                    deleted.map((id) => {
                      //console.log("comment deleted " + id);
                      //this.comments[comment];
                      self.deleteComment(id);
                      //delete this.comments[id];
                    });
                  }
                );
              }
            );

            let annotations = {};

            comments.forEach((comment) => {
              comment.attributes.meta = JSON.parse(
                comment.attributes.meta.value
              );
              if (!annotations[comment.attributes.meta.annotation]) {
                annotations[comment.attributes.meta.annotation] = {
                  id: comment.attributes.meta.annotation,
                  range: comment.attributes.meta.range,
                  shape: comment.attributes.meta.shape,
                  comments: [],
                };
              }

              annotations[comment.attributes.meta.annotation].comments.push({
                id: comment.id,
                meta: comment.attributes.meta.meta,
                body: comment.attributes.comment.value,
              });
            });
            let annotationsObjects = Object.keys(annotations).map((key) => {
              return annotations[key];
            });
            annotationsObjects.map((annotation) => {
              annotation.comments.map((comment) => {
                this.comments[comment.id] = comment;
              });
            });

            if (
              this.allowCommenting == true ||
              comments.length ||
              window.drupalSettings.user.role == "coach" ||
              window.drupalSettings.user.role == "administrator"
            ) {
              this.plugin[this.uuid] = this.player[
                this.uuid
              ].annotationComments({
                annotationsObjects: annotationsObjects,
                meta: {
                  user_id: window.drupalSettings.user.uid,
                  user_name: window.drupalSettings.user.username,
                },
                bindArrowKeys: true,
                showControls: true,
                showCommentList: true,
                showFullScreen: true,
                showMarkerShapeAndTooltips: true,
                internalCommenting: true,
                startInAnnotationMode: true,
                permissionToDeleteComment: (comment) => {
                  return comment.meta.user_id == window.drupalSettings.user.uid;
                },
                permissionToDeleteAnnotation: function (comment_list) {
                  return (
                    window.drupalSettings.user.role == "administrator" ||
                    window.drupalSettings.user.role == "coach"
                  );
                },
              });
            }
          }
        } catch (error) {
          console.log(error);
        }
      });
    }
  },
  methods: {
    uploadFile(buffer, name) {
      let fetch_headers = new Headers();
      fetch_headers.append("Content-Type", "application/octet-stream");
      fetch_headers.append("X-CSRF-Token", this.token);
      fetch_headers.append(
        "Content-Disposition",
        contentDisposition(name, { type: "file" })
      );
      return fetch(this.fileurl, {
        credentials: "include",
        method: "POST",
        headers: fetch_headers,
        body: buffer,
      })
        .then((response) => {
          return response.json();
        })
        .then((json) => {
          this.errorMessage = "";
          if (json.errors && json.errors.length) {
            // this.uploaded = true;
            this.error = true;
            let errorMessage = json.errors[0].detail.split(/\n/);

            if (
              errorMessage[1] &&
              errorMessage[1].match(/following extensions are allowed/)
            ) {
              let extensionsList = errorMessage[1].match(
                /following extensions are allowed:(.+)\./
              );
              this.errorMessage =
                extensionsList && extensionsList[1]
                  ? "Only files with the following extensions are allowed: " +
                    extensionsList[1]
                  : "";
            }
            // setTimeout(() => {
            //   this.$emit('upload-file-fail');
            // }, 3000)
            this.$emit("update-error", false);
            return;
          }
          this.uuid = json.data.id;
          this.uri = json.data.attributes.uri.url;
          this.name = json.data.attributes.filename;
          //this.uploaded = true;
          this.filemime = json.data.attributes.filemime;


          console.log(this.filemime);
          this.options = {
            controls: true,
            fluid: true,
            sources: [
              {
                src: this.uri,
                type: this.filemime,
              },
            ],
          };
          this.dataProps.buffer = null;
          try {
            setTimeout(() => {
              this.player = videojs(
                this.$refs.videoPlayer,
                this.options,
                function onPlayerReady() {
                  // console.log("onPlayerReady", this);
                }
              );
            }, 100);
          } catch (error) {
            console.log(error);
          }
          this.$emit("upload-file", {
            uri: this.uri,
            name: this.name,
            uuid: this.uuid,
            filemime: this.filemime,
          });
        })
        .catch((error) => {
          //this.uploaded = true;
          this.error = true;
          this.errorMessage = "";
          this.dataProps.buffer = null;
          this.$emit("update-error", false);
          // setTimeout(() => {
          //   this.$emit('upload-file-fail');
          // }, 3000)
        });
    },
  },
  beforeDestroy() {
    if (this.player) {
      this.player.dispose();
    }
  },
  watch: {
    cleanError(val) {
      if (val == true && this.error) {
        this.$emit("upload-file-fail");
      }
    },
  },
};
</script>

<style lang="scss">
.file-wrapper {
  position: relative;
}
.delete-icon-uploaded {
  position: absolute;
  top: 0;
  right: 18px;
  background-color: rgba($color: #ffffff, $alpha: 0.8);
}
.messages--error.file-error {
  padding-right: 50px;
  position: relative;
  margin-top: 0;
  .md-button {
    position: absolute;
    top: 50%;
    margin-top: -20px;
    right: -6px;
  }
}
.video-uploaded {
  width: 100%;
  min-height: 300px;
  margin-bottom: 15px;
  max-height: 450px;
  overflow: hidden;
  .video-js.vjs-fluid {
    padding-top: 450px !important;
  }
}
</style>
